var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSouthFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 170,
    viewBox: "0 0 200 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 80.5L27 81.5L38.5 57.5L46.5 55.5V46.5L60.5 44L61.5 52L105 39L103 42L72.5 80.5Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 81H80V144.902L34.5 118.634V81Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 40.5L73 77.5V80.5H80V145.5L124.5 122.5V77.5H133L105 40.5Z",
    stroke: "#FF0000",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98 134.5V88.5H111V129L98 134.5Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 91.5L50 92.5V110.5L41 109.5V91.5Z",
    fill: "#FF0000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 93.5L70 95.5V113.5L57 111.5V93.5Z",
    fill: "#FF0000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.184 53.9999C174.186 56.436 173.218 58.772 171.497 60.4956C169.775 62.2192 167.439 63.1872 165.003 63.1888C162.567 63.1888 160.231 62.2223 158.507 60.5002C156.784 58.7782 155.816 56.442 155.816 54.0061C155.816 51.5702 156.782 49.2324 158.506 47.5104C160.228 45.7883 162.564 44.8203 165 44.8203C167.434 44.8203 169.77 45.7868 171.492 47.5088C173.214 49.2294 174.183 51.5652 174.184 53.9999ZM165 39L162.85 42.7257L167.15 42.7273L165 39ZM167.15 65.265H162.85L165 69L167.15 65.265ZM150 53.9999L153.726 56.1498L153.727 51.85L150 53.9999ZM176.265 51.85V56.1498L180 53.9999L176.265 51.85ZM175.608 43.3919L171.451 44.5077L174.492 47.5486L175.608 43.3919ZM158.549 63.5012L155.508 60.4603L154.392 64.6075L158.549 63.5012ZM154.392 43.3919L155.508 47.5487L158.549 44.5077L154.392 43.3919ZM174.501 60.4511L171.46 63.4921L175.617 64.6078L174.501 60.4511Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthFace);
export default __webpack_public_path__ + "static/media/SouthFace.54232271a76a6a84a8a37bbba328cf32.svg";
export { ForwardRef as ReactComponent };